<template>
  <div class="questionnaire vertical-cards">
    <div
      class="background"
      v-if="$store.state.settings.background && $store.state.settings.background.enabled"
      :style="`background: ${$store.state.settings.background.color.hex}`"
    ></div>

    <div class="questionnaire__questions" v-if="!hasFinishedQuestionnaire">
      <Question v-for="(question, index) in questions" :question="question" :key="index" />
    </div>

    <div class="questionnaire__results" v-if="hasFinishedQuestionnaire">
      <div class="questionnaire__results__title">
        {{ resultsPageTitle }}
      </div>
      <div class="questionnaire__results__subtitle">
        {{ resultsPageDescription }}
      </div>

      <Result v-for="(result, index) in results" :result="result" :key="index" />

      <SocialSharing v-if="$store.state.settings.socialSharing.enabled" :results="results" />

      <div class="reset-questionnaire" @click="$store.dispatch('resetQuestionnaire')">
        もう一度診断
      </div>
    </div>

    <ProgressBar v-if="$store.state.settings.progressBar.enabled" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Question from '@/components/vertical-cards/Question.vue'
import Result from '@/components/vertical-cards/Result.vue'
import SocialSharing from '@/components/shared/SocialSharing.vue'
import ProgressBar from '@/components/shared/ProgressBar.vue'

export default {
  props: {
    hasFinishedQuestionnaire: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Question,
    Result,
    SocialSharing,
    ProgressBar
  },
  computed: {
    ...mapState(['settings', 'questions']),
    ...mapGetters(['results']),
    resultsPageTitle () {
      if (this.settings.resultsPage) {
        return this.settings.resultsPage.title
      }
      return 'Results'
    },
    resultsPageDescription () {
      if (this.settings.resultsPage) {
        return this.settings.resultsPage.description
      }
      return 'Here are our recommendations based on your answers.'
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 48px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'M PLUS 1p', sans-serif;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__results {
    &__title {
      font-size: 22px;
      font-weight: 800;
      margin-bottom: 12px;
      text-align: center;
    }

    &__subtitle {
      margin-bottom: 28px;
      text-align: center;
    }
  }

  .reset-questionnaire {
    text-align: center;
    font-size: 12px;
    color: #9b59b6;
    margin-top: 28px;
    cursor: pointer;
  }
}
</style>
